import { gql } from "@/__generated__/gql";

export const FEED_POST_QUERY = gql(`
  query FeedPost($id: ID!) {
    node(id: $id) {
      ... on FeedPost {
        id
        name
        caption
        ctaText
        ctaUrl
        publishDate
        image {
          id
          url(size: 400)
          width
          height
        }
        video {
          id
          url
          width
          height
        }
        postedBy {
          id
          firstName
          lastName
          profilePhoto {
            id
            url(size: 100)
          }
        }
        organization {
          id
          name
        }
      }
    }
  }
`);
